import React, { useContext } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import {parse} from 'date-fns';
import MultiSelectFilter from './MultiSelect';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const FilterOverlayTrigger = ({column, colName, isDate, isNested, nestedObjectField, isTotalColumn,
                                filterData, data, columnFilterIndexes, columnFilterOptions, 
                                setFilterData, setColumnFilterIndexes, setColumnFilterOptions, 
                                handlerCheckDetailsFilterApplied, isDropdown, isRuleValue,
                                isNestedArray, isOverviewColumnFilter, handlerCheckOverviewFilterApplied
                            }) => {

    const languageContext = useContext(LanguageContext);

    const getFilterData = (fData) => {
        setFilterData(fData);
    }
                                
    const getSelectedColumnFilterIndexes = (colIndex, isInsert) => {
        if(isInsert) {
            if((columnFilterIndexes && columnFilterIndexes.length === 0) || 
                columnFilterIndexes.some(c=>c !== colIndex)) {
                let arr = columnFilterIndexes;
                arr.push(colIndex)
                setColumnFilterIndexes(arr);
            }
        } else {
            if(columnFilterIndexes && columnFilterIndexes.length > 0 && 
                columnFilterIndexes.some(c=>c === colIndex)) {
                setColumnFilterIndexes(columnFilterIndexes.filter(f=>f !== colIndex));
            }
        }
    }

    const getColumnFilterOptions = (colIndex, isInsert, optData) => {
        if(isInsert) {
            if((columnFilterOptions && columnFilterOptions.size === 0) || 
                (!columnFilterOptions.has(colIndex)) || (columnFilterOptions.has(colIndex))) {
                setColumnFilterOptions(columnFilterOptions.set(colIndex,optData));
            } 
        } 
    }

    const closePopoverHandler = (ev, colIndex) => {
      ev.stopPropagation();
      let btn=document.querySelector(("#filterIcon"+colIndex));
      btn.click(ev.stopPropagation())
      btn.focus();
    }

    const columnIndex=column.columnIndex;

    const sortObjectOptionValues = (optionValue, isDateValue) => {
        if(!isDateValue) {
            let value = (optionValue.replace(/\./g, "")).replace(/\,/g, ".");
            return value && value.trim() !== "" && Number(value);
        } else {
            return parse(optionValue, "dd/MM/yyyy", new Date())
        }
    }

    const getNestedArrayValues =(itemObj, nestedArrayObj, fieldName) => {
        let arr = itemObj.map(item=>item[nestedArrayObj].map(el=>el[fieldName]));
        let flatArrValue= [].concat.apply([], arr);
        return flatArrValue;
    }

    const getUniqueOptionsValue = (field, colIndex, isNestedValue, nestedObjectFieldValue, isDateValue, 
                                    isTotalColumnValue, isDropdownValue, isNestedArrayValue) => {
        const dtlData = columnFilterIndexes && (columnFilterIndexes.length > 1 || columnFilterIndexes.some(d=>d !==colIndex))
                        && filterData && filterData.length > 0 ? filterData : data;
        
        let optionsValue =  !isNestedArrayValue ? 
                            [...new Map(dtlData.map(item=>
                                (!nestedObjectFieldValue) ? 
                                isDropdownValue ? [item[field], {label: languageContext.labels[(item[field]).toLowerCase()], value: languageContext.labels[(item[field]).toLowerCase()]}]
                                : isRuleValue ? [item[field], {label: languageContext.labels[(item[field])], value: languageContext.labels[(item[field])]}]
                                : [item[field], {label: item[field], value: item[field]}]
                                : isRuleValue ? [item[nestedObjectFieldValue][field], {label: languageContext.labels[(item[nestedObjectFieldValue][field])], value: languageContext.labels[(item[nestedObjectFieldValue][field])]}]
                                : [item[nestedObjectFieldValue][field], {label: item[nestedObjectFieldValue][field], value: item[nestedObjectFieldValue][field]}]
                                )).values()] 
                            : [...new Map(getNestedArrayValues(dtlData, nestedObjectField, field)
                                .map(item=>
                                isRuleValue ? [item, 
                                    {
                                    label: languageContext.labels[(item)], 
                                    value: languageContext.labels[(item)]
                                    }    
                                ]
                                : [item, {label: item, value: item}]
                             )).values()];

        if(((isNestedValue && !isNestedArray) || (isNestedValue && isNestedArray && isDateValue)
        || isTotalColumnValue) && optionsValue.length > 0) {
           optionsValue.sort((x, y)=>{
                let xValue = sortObjectOptionValues(x.value, isDateValue);
                let yValue = sortObjectOptionValues(y.value, isDateValue);
                return xValue - yValue;
            })
        }
        else if(!isNestedValue &&  !isNestedArray && isDateValue) {
            optionsValue.sort((x, y)=>{
                return x.value.localeCompare(y.value);
            })
        } 
        else {
            optionsValue.sort((x, y)=>{
               return x.value > y.value ? 1 : x.value < y.value ? -1 : 0;
            });
        }  
        
        if(columnFilterIndexes && columnFilterIndexes.length > 1 &&
           columnFilterOptions && columnFilterOptions.size > 0 && columnFilterOptions.has(colIndex)) {
            setColumnFilterOptions(columnFilterOptions.set(colIndex, optionsValue));                                 
        }
        return optionsValue;    
    }

    return ( <div className="filter-overlay" onClick={e => {
                e.stopPropagation(); }}
                onKeyUpCapture={e=>{e.stopPropagation(); }}
            >
     <OverlayTrigger
    trigger="click"
    rootClose
    key={"bottom"}
    placement={"bottom"}
    overlay={
      <Popover id={`popover-positioned-bottom`+columnIndex} onClick={e => {
          e.stopPropagation();
        }} onKeyDown={e=>{e.stopPropagation();}}>
        <Popover.Content>
        <MultiSelectFilter onFilter={getFilterData} column={ column } 
                          data={columnFilterIndexes && (columnFilterIndexes.length > 1 || 
                              (columnFilterOptions && !columnFilterOptions.has(columnIndex))) 
                              && filterData && filterData.length > 0 ? filterData :  data} 
                          options={() => getUniqueOptionsValue(colName, columnIndex, isNested, 
                                nestedObjectField, isDate, isTotalColumn, isDropdown, isNestedArray)}
                          getSelectedColumnFilterIndexes={getSelectedColumnFilterIndexes}
                          getColumnFilterOptions={getColumnFilterOptions}
                          columnFilterOptions={columnFilterOptions && columnFilterOptions.has(columnIndex) ? 
                                columnFilterOptions : new Map().set(columnIndex, 
                                getUniqueOptionsValue(colName, columnIndex, isNested, nestedObjectField, 
                                    isDate, isTotalColumn, isDropdown, isNestedArray))}
                          field={colName}
                          closePopoverHandler={closePopoverHandler}
                          isDate={isDate}
                          handlerCheckDetailsFilterApplied={isOverviewColumnFilter ? handlerCheckOverviewFilterApplied 
                                                            : handlerCheckDetailsFilterApplied}
                          isNested={isNested}
						  isRuleValue={isRuleValue}
                          nestedObjectField={nestedObjectField}
                          isDropdown = {isDropdown}
                          isNestedArray={isNestedArray}
                          isOverviewColumnFilter={isOverviewColumnFilter}
                          columnFilterIndexes={columnFilterIndexes}
                          />
        </Popover.Content>
      </Popover>
    }
  >
    <div id={"filterIcon"+ columnIndex} role="button" tabIndex="0" 
        onKeyDownCapture={(e)=>{ 
            if (e.key === "Enter")
            {
                closePopoverHandler(e, columnIndex)
            }}
        }
    >
    <FontAwesomeIcon className={((columnFilterOptions && columnFilterOptions.has(columnIndex)) 
                || (columnFilterIndexes && columnFilterIndexes.length > 0 && columnFilterIndexes.includes(columnIndex))) ? 
               "active-filter-icon" : "inactive-filter-icon"}
         icon= {faFilter} />
    </div>    
  </OverlayTrigger> </div>)
}

export default FilterOverlayTrigger;